import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BrandingConfigurationService } from '@ptl/brand';
import { HTTPWrapperContext, NormalizedResponse, RequestConfigImplementation, REQUEST_METHODS, XHR_STRATEGIES } from '@ptl/xhr';

@Injectable({
  providedIn: 'root'
})
export class ServerDateTimeService {

  constructor(
    private httpClient: HTTPWrapperContext,
    private brandService: BrandingConfigurationService
  ) { }

  async getServerDateTime() {
    const requestConfigImplementation = new RequestConfigImplementation({
      method: REQUEST_METHODS.GET,
      url: '/cmcrst/x-services/dateService/getDateTime',
      headers: new HttpHeaders({
        ddToken: this.brandService.getCurrentBrand().ddToken_encoded()
      })
    });
    this.httpClient.setStrategy(XHR_STRATEGIES.DATAPOWER_MIDDLEWARE);
    return this.httpClient.makeRequest<NormalizedResponse<{currentCustomDateTime: string}>>(requestConfigImplementation);
  }
}
